import React, { useState, useEffect } from "react";
import { fetchJson, post } from "../../lib/Fetching";
import styled from "styled-components";
import Button from "../Button";
import Link from "../Link";
import TurnaroundPremiumForm from "./TurnaroundPremiumForm";

const TurnaroundContainer = styled.div`
  border: 1px solid #eee;
  margin-bottom: 10px;
  padding: 10px;
  h4 {
    margin-top: 0px;
    font-size: 12pt;
    color: #888;
  }
`;

const Delete = styled(Link)`
  color: red;
`;

export default function TurnaroundPremiums({ quote_group_id, attempt_id }) {
  const [loaded, setLoaded] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [turnaroundPremiums, setTurnaroundPremiums] = useState([]);

  const fetchTurnaroundPremiums = () =>
    fetchJson("/quoting/turnaround_premiums.json", {
      attempt_id,
      quote_group_id
    }).then(json => {
      setTurnaroundPremiums(json.turnaroundPremiums);
      setLoaded(true);
    });

  const addPremium = ({ turnaround, premium }) => {
    post("/quoting/turnaround_premiums.json", {
      attempt_id,
      quote_group_id,
      turnaround,
      premium
    })
      .then(json => fetchTurnaroundPremiums())
      .catch(errors => alert(errors));
  };

  const removePremium = turnaround => {
    post(
      "/quoting/turnaround_premiums/destroy.json",
      {
        attempt_id,
        quote_group_id,
        turnaround
      },
      "DELETE"
    )
      .then(json => fetchTurnaroundPremiums())
      .catch(errors => alert(errors));
  };

  useEffect(() => {
    fetchTurnaroundPremiums();
  }, [quote_group_id]);

  const renderForm = () => {};

  const renderTurnarounds = () => {
    return (
      <div>
        <Button tiny title="Add Turnaround Premium" onClick={() => setShowForm(!showForm)} />
        {showForm && <TurnaroundPremiumForm onSubmit={addPremium} />}
        {turnaroundPremiums.length > 0 && (
          <table className="table table-condensed">
            <thead>
              <tr>
                <th style={{ width: 30 }} />
                <th>Turnaround (days)</th>
                <th>Premium %</th>
              </tr>
            </thead>
            <tbody>
              {turnaroundPremiums.map(tp => (
                <tr key={tp.turnaround}>
                  <td>
                    <Delete
                      onClick={() => removePremium(tp.turnaround)}
                      className="fa fa-trash"
                    />
                  </td>
                  <td>{tp.turnaround}</td>
                  <td>{tp.premium}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  };

  return (
    <TurnaroundContainer>
      <h4>Turnaround Premiums</h4>
      {loaded ? renderTurnarounds() : <p>Loading...</p>}
    </TurnaroundContainer>
  );
}
